// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const WarningIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 22 20">
    <path
      fill="currentColor"
      d="M10.99 2a1 1 0 0 1 .92.53l7.93 13.73a1.07 1.07 0 0 1-.93 1.61H3.06a1.07 1.07 0 0 1-.92-1.61l7.92-13.73a1.1 1.1 0 0 1 .93-.53m0-1.5a2.6 2.6 0 0 0-2.27 1.28L.84 15.51a2.58 2.58 0 0 0 2.22 3.86h15.85a2.58 2.58 0 0 0 2.23-3.86L13.21 1.78A2.5 2.5 0 0 0 10.99.5"
    />
    <path
      fill="currentColor"
      d="M11.74 7.92a.75.75 0 0 0-1.5 0v3.5a.75.75 0 0 0 1.5 0zM10.99 15.17a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
    />
  </svg>,
  "Warning",
);
export default WarningIcon;
